import { render } from "./PlayHome.vue?vue&type=template&id=2c8f0a66"
import script from "./PlayHome.vue?vue&type=script&lang=js"
export * from "./PlayHome.vue?vue&type=script&lang=js"

import "./PlayHome.vue?vue&type=style&index=0&id=2c8f0a66&lang=css"

import exportComponent from "C:\\BiggerInside\\Protocol223-Portal\\portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__